export const STOCK_TRANSPORT_ORDER_EN = {
  number: 'Stock Transport Order Number',
  title: 'Stock Transport Order Management',
  titleDetail: 'Stock Transport Order Detail',
  createStockTO: 'Create Stock Transport Order',
  all: 'All',
  created: 'Created',
  rejected: 'Rejected',
  awaiting_logistic: 'Awaiting Logistic',
  awaiting_inbound: 'Awaiting Inbound',
  inbounded: 'Inbounded',
  stockTransportQuantity: 'Stock Transport Quantity',
}
